import { Component, OnInit, OnDestroy } from '@angular/core';
import { RetrievePnrLocatorComponent } from './retrieve-pnr-locator.component';
import { Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { DEFAULT_LANGUAGE } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-retrieve-pnr-locator',
	templateUrl: './retrieve-pnr-locator.indra.component.html',
	styleUrls: ['./retrieve-pnr-locator.component.scss'],
	host: { class: 'app-retrieve-pnr-locator' }
})
export class INDRARetrievePnrLocatorComponent extends RetrievePnrLocatorComponent implements OnInit, OnDestroy {

	groupRequiredLetter = 'G';

	form: FormGroup;
	submitted = false;
	submitTry = false;
	
	allSubs: Subscription[] = [];

	userInfo$: Observable<Object> = this.store.select(fromStore.getUserInfo);
	isLoggedIn: boolean = false;
	userInfo;
	isAlive = true;
	token: string;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private store: Store<fromStore.State>
	) {
		super();

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((user: any) => {
				if (user) {
					this.token = user.flyTapLogin;
					this.isLoggedIn = true;
					this.userInfo = user;
				} else {
					this.token = null;
					this.isLoggedIn = false;
					this.userInfo = null;
				}
			});
	}

	ngOnInit() {
		this.form = this.fb.group({
			pnr: [
				'',
				[
					Validators.required,
					Validators.minLength(6),
					Validators.maxLength(13),
					Validators.pattern('^([A-Za-z0-9_]{6}|047([0-9]{10}))$')
				]
			],
			last_name: ['', [Validators.required, Validators.pattern('^[^0-9]*$')]]
		});

		this.onChanges();
	}
	
	ngOnDestroy() {
		this.isAlive = false;
		for (let sub of this.allSubs) {
			if (sub) { sub.unsubscribe(); }
		}
	}

	onChanges(): void {
		const formValueSub = 
			this.form.valueChanges.subscribe(val => {
				this.submitTry = false;
			});
			
		this.allSubs.push(formValueSub);
	}

	INDRA_showErros() {
		return !this.form.valid && this.submitTry;
	}

	INDRA_PNRhasError() {
		return this.INDRA_showErros() && (this.form.controls['pnr'].hasError('required') 
			|| this.form.controls['pnr'].hasError('pattern') || this.form.controls['pnr'].hasError('minlength') 
			|| this.form.controls['pnr'].hasError('maxlength'));
	}

	INDRA_LastNamehasError() {
		return this.INDRA_showErros() && (this.form.controls['last_name'].hasError('required') 
			|| this.form.controls['last_name'].hasError('pattern'));
	}

	INDRA_findBooking() {
		// https://tpuat.suitairibe.com/my-bookings/details?pnr=${PNR}&lastname=${surname}&source=flytap&market=<market>&language=<language>
		this.submitTry = true;

		// stop here if form is invalid
		if (this.form.valid) {
			this.submitted = true;

			const key = 'externalURLs.myTripsManageBooking';
			const url = this.ibeAdminConfigService.getConfigurationValue(key);
			let myBookingsUrl = url.replace('${surname}', this.form.value.last_name).replace('${PNR}', this.form.value.pnr.toUpperCase());
			myBookingsUrl += '?source=flytap';
			const selectedMarketCode = sessionStorage.getItem('market');
			const selectedLanguageCode = sessionStorage.getItem('language');
			if (selectedMarketCode) {
				myBookingsUrl += '&market=' + selectedMarketCode;
			}
			if (selectedLanguageCode) {
				myBookingsUrl += '&language=' + selectedLanguageCode;
			}
			if (this.isLoggedIn && this.token) {
				myBookingsUrl += '&uid=' + this.token;
			}
			
			return window.open(myBookingsUrl);
		} /* else if (this.form.invalid) {
			const firstElementWithError = document.querySelectorAll('form .ng-invalid');
			if (firstElementWithError.length) {
				const elFirstElementWithError = firstElementWithError[0].getElementsByTagName('input')[0] as HTMLElement;
				elFirstElementWithError.scrollIntoView({block: "center", inline: "center", behavior: "smooth"});
				elFirstElementWithError.focus();
			}
		} */
    }
}
